<template>
    <div>
        <iframe
            v-if="checkOriginUrl"
            :data-originurl="dataOriginUrl"
            :src="src"
            :data-aditional-params="additionalParams"
            ref="iframe"
            id="seven-plugin-live"
            :data-type="isMobile ? 'mobile' : 'desktop'"
            scrolling="no"
            frameborder="0"
            class="frame"
        />
    </div>
</template>

<script>
    import { iframeResizer } from 'iframe-resizer';
    import config from '@config';
    import { IFrameMessageTypes } from '../enums';

    export default {
        name: 'FrameComponent',
        props: {
            gameSlug: {
                type: String,
                required: true,
            },
            checkOriginUrl: {
                type: String,
                required: true,
            },
            isMobile: {
                type: Boolean,
                required: true,
            },
            demoGameUrl: {
                type: String,
                required: true,
            },
            fullGameUrl: {
                type: String,
                required: true,
            },
            sessionId: {
                type: String,
                required: false
            },
            additionalParams: {
                type: String,
                default: '',
            },
            balance: {
                type: Number,
                required: false,
                default: null,
            }
        },
        data() {
            return {
                canSendMessagesToIframe: false,
            };
        },
        mounted() {
            this.iframeMessageData = {
                checkOrigin: [this.checkOriginUrl],
                // handle messages sent from iframe content to our app
                messageCallback: (data) => {
                    if (data.message && data.message.type) {
                        switch (data.message.type) {
                            case IFrameMessageTypes.loginRequired:
                                this.$emit('loginRequired');
                                break;
                            case IFrameMessageTypes.insufficientFounds:
                                this.$emit('insufficientFunds');
                                break;
                            case IFrameMessageTypes.contentLoaded:
                                if (this.sessionId) {
                                    this.notifyIframeThatBalanceHaveChanged(this.balance);
                                }
                                this.$emit('contentLoaded');
                                break;
                            case IFrameMessageTypes.ticketResolved:
                                this.$emit('ticketResolved');
                                break;
                            case IFrameMessageTypes.listenersReady:
                                this.canSendMessagesToIframe = true;
                                break;
                            default:
                                break;
                        }
                    }
                }
            };
            iframeResizer(this.iframeMessageData, this.$refs.iframe);
        },
        watch: {
            balance(newValue, oldValue) {
                if (this.canSendMessagesToIframe && newValue !== oldValue) {
                    this.notifyIframeThatBalanceHaveChanged(newValue);
                }
            }
        },
        computed: {
            gameUrl() {
                if (!this.sessionId) {
                    return this.stripQueryParams(this.demoGameUrl);
                }
                return this.stripQueryParams(this.fullGameUrl);
            },
            dataOriginUrl() {
                if (this.checkOriginUrl === config.services.virtual.host) {
                    return `${this.checkOriginUrl}/${this.gameSlug}`;
                }
                return this.gameUrl.split('?')[0];
            },
            src() {
                let src = this.gameUrl;
                if (this.sessionId) {
                    const sessionIdParts = this.sessionId.split('|');
                    src = src.replace('{SESSIONTOKEN}', sessionIdParts[0]).replace('{USERID}', sessionIdParts[1]);
                }
                if (this.isMobile) {
                    return `${src}&layout=mob`;
                }
                return src;
            },
        },
        methods: {
            stripQueryParams(url) {
                if (this.isMobile) {
                    return url;
                }
                return url.replace('&layout=mob', '').replace('&mobile=true', '&mobile=false');
            },
            notifyIframeThatBalanceHaveChanged(balance) {
                try {
                    this.$refs.iframe.contentWindow.postMessage(
                        {
                            type: 'balanceChanged',
                            content: {
                                balance
                            },
                        },
                        this.checkOriginUrl
                    );
                } catch (e) {
                    // ignore
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/games/virtuals/components/Game.vue